module.exports = __webpack_public_path__ + "img/g9.3de4dd70.png";